import React, { useEffect, useState } from "react";
import classes from "./RegisterZipGame.module.css";
import Header from "../../components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import ZipGameStepperLogin from "../../components/ZipGameStepperLogin";
import { loginZipUser } from "../../http/http";
import { useDispatch } from "react-redux";
import { setUserZip } from "../../store/slices/userZipGameTokenSlice";
import { toast } from "react-toastify";

const LoginVerifyZipOtp = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const dispatch = useDispatch();

    const msisdn = location?.state?.msisdn || "";
    const [otp, setOtp] = useState(["", "", "", ""]);

    useEffect(() => {
        if (!msisdn) {
            navigate("/login/zip-game");
        }
    }, [msisdn, navigate]);

    const handleOtpChange = (index, value) => {
        if (!/^\d?$/.test(value)) return;

        const updatedOtp = [...otp];
        updatedOtp[index] = value;
        setOtp(updatedOtp);

        if (value && index < 3) {
            const nextInput = document.getElementById(`otp-${index + 1}`);
            if (nextInput) nextInput.focus();
        }
    };

    const handleOtpKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            const prevInput = document.getElementById(`otp-${index - 1}`);
            if (prevInput) prevInput.focus();
        }
    };

    const handleNext = async () => {
        const finalOtp = otp.join("");
        if (finalOtp.length !== 4) return;

        try {

            const response = await loginZipUser(msisdn);
            console.log(response?.data?.result, 'response-');

            if (response?.data?.result?.loginStatus == 1) {
                dispatch(setUserZip(response?.data?.result));
                // user is login success
                navigate("/zip-game-details");
            }
            else {
                // you are not registered!
                toast.error("You are not registered!");
            }

        } catch (error) {
            console.log(error, 'error-');
        }

    };

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.heroCard}>
                    <div className={classes.heroBadge}>ZIP GAME</div>
                    <h1 className={classes.heroTitle}>Verify OTP</h1>
                    <p className={classes.heroText}>
                        Enter the OTP sent to your mobile number to continue login.
                    </p>
                </div>

                <ZipGameStepperLogin currentStep={2} />

                <div className={classes.formCard}>
                    <div className={classes.section}>
                        <div className={classes.sectionHead}>
                            <h2 className={classes.sectionTitle}>OTP Verification</h2>
                            <p className={classes.sectionText}>
                                Enter the 4-digit OTP sent to +236 {msisdn}
                            </p>
                        </div>

                        <div className={classes.otpWrapper}>
                            {otp.map((digit, index) => (
                                <input
                                    key={index}
                                    id={`otp-${index}`}
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={1}
                                    value={digit}
                                    className={classes.otpInput}
                                    onChange={(e) => handleOtpChange(index, e.target.value)}
                                    onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                />
                            ))}
                        </div>

                        <div className={classes.actionRow}>

                            <button type="button" className={classes.primaryBtn} onClick={handleNext}>
                                Verify OTP
                            </button>
                            <button
                                type="button"
                                className={classes.secondaryBtn}
                                onClick={() => navigate(-1)}
                            >
                                Back
                            </button>
                        </div>

                        <button type="button" className={classes.linkBtn}>
                            Resend OTP
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoginVerifyZipOtp;